module.exports = __webpack_public_path__ + "images/CEBSB_goodnews_bg_down_2025_2026.1790128953909.jpg";